var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Search.module.scss';
import { useUpdateEffect } from '../../hooks';
import { Magnifier, CloseRoundSmall } from '../../assets/icons';
import { Input } from '../Input/Input';
var Search = function (_a) {
    var data = _a.data, searchProperty = _a.searchProperty, label = _a.label, placeholder = _a.placeholder, disabled = _a.disabled, small = _a.small, noMargin = _a.noMargin, id = _a.id, className = _a.className, dataId = _a.dataId, autoFocus = _a.autoFocus, onSearch = _a.onSearch, shouldReset = _a.shouldReset, setShouldReset = _a.setShouldReset;
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var onDataSearch = function () {
        var searched = data.filter(function (d) { return d[searchProperty].toLowerCase().includes(value.toLowerCase()); });
        onSearch(searched);
    };
    var onValueClear = function () {
        setValue('');
    };
    useUpdateEffect(function () {
        onDataSearch();
    }, [value]);
    return (_jsxs("section", __assign({ className: "".concat(styles.Search, " ").concat(small ? styles.Small : '') }, { children: [_jsx(Input, { value: value, label: label, placeholder: placeholder, disabled: disabled, small: small, icon: _jsx(Magnifier, {}), noMargin: noMargin, onChange: setValue, id: id, className: className, inputClassName: styles.SearchInput, dataId: dataId, autoFocus: autoFocus, shouldReset: shouldReset, setShouldReset: setShouldReset }), value && _jsx(CloseRoundSmall, { className: styles.Clear, onClick: onValueClear })] })));
};
Search.propTypes = {
    searchProperty: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    small: PropTypes.bool,
    noMargin: PropTypes.bool,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
    shouldReset: PropTypes.bool,
    setShouldReset: PropTypes.func,
};
Input.defaultProps = {
    placeholder: 'Search',
    autoFocus: false,
};
export { Search };
//# sourceMappingURL=Search.js.map